import IndexModel from "@/service/v10/sigap/IndexModel";

class SegundaChamadaService extends IndexModel {
    constructor() {
        super();
        this.url = this.url + '/SegundaChamada';
    }

    public getApiUrl() {
        return this.getAxios().defaults.baseURL + this.url;
    }

    public getStatus(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(this.url + '/GetStatus', {})
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }

    public getModel(id): Promise<any> {
        return new Promise((resolve, reject) => {
            this.getAxios().get(this.url + '/' + id)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response);
                })
        });
    }
}

export default SegundaChamadaService;
